import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { SslCertificatesState } from './types'
import { ICertificate } from '@/types/certificate.interface'

const initialState: SslCertificatesState = {
  list: [],
}

const sslCertificatesSlice = createSlice({
  name: 'ssl-certificates',
  initialState,
  reducers: {
    setSslCertificates: (state, action: PayloadAction<ICertificate[]>) => {
      state.list = action.payload.filter((certificate) => certificate.active)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.sslCertificates,
      }
    })
  },
})

export const { setSslCertificates } = sslCertificatesSlice.actions

export default sslCertificatesSlice
